import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../button/Button';
import OutlineErrorIcon from '../../../icons/OutlineError.icon';

export const ConfirmMessageContent = React.forwardRef((props, ref) => {
  const {
    message,
    onAcceptAction = () => {
      ref?.current && ref?.current.close()
    },
    onCancelAction = () => {
      ref?.current && ref?.current.close()
    },
    title,
  } = props;

  return (

    <React.Fragment>
      <div className="text-center"><OutlineErrorIcon stroke="#FFA136"/></div>
      <h3 className="modal-title text-center pt-1 pb-3">{title}</h3>
      <p className="text-center">{message}</p>
      <div className="d-flex justify-content-center p-2">
        <Button label="Cancelar" onClick={onCancelAction} theme={{outline: true}}/>
        <Button className="ml-2" label="Aceptar" onClick={onAcceptAction}/>
      </div>
    </React.Fragment>
  );
});

ConfirmMessageContent.propTypes = {
  message: PropTypes.string,
  onAcceptAction: PropTypes.func,
  onCancelAction: PropTypes.func,
  ref: PropTypes.object,
};

export default React.memo(ConfirmMessageContent);
